/* eslint-disable import/first */
/* eslint-disable prettier/prettier */
// @flow

import { CallToAction, Flyer } from 'types/FlyerTypes'

import React from 'react'
import { connect } from 'react-redux'
import { Link } from '../../../../../../shared/components/Link'
import { Icon } from 'semantic-ui-react'
import { css } from 'emotion'
import { white, silver, prussian } from 'constants/inlineStyles'

import { ModalTypes, openModal } from '../../redux'

import withMetricClick from '../../withMetricClick'
import FlyerButton from './components/FlyerButton'
import SocialIcons from './components/SocialIcons'
import { getActiveFlyer, getFlyerCtas } from '../../selectors'
import { isIOS, isBrowser } from 'react-device-detect'
import { ctaTexts } from '@peachjar/flyer-email-builder/dist/api/FlyerEmail'
import { capitalize } from 'lodash'

let styles = {}

type ReduxStateProps = {|
  +primaryCTA: ?CallToAction,
  +secondaryCTA: ?CallToAction,
  +thirdCTA: ?CallToAction,
  +fourthCTA: ?CallToAction,
  +fifthCTA: ?CallToAction,
  +flyer: ?Flyer
|}

type ReduxDispatchProps = {|
  +onOpenModal: (modalType: ?ModalTypes) => void
|}

type OwnProps = {|
  resource: string,
  resourceId: string,
  // eslint-disable-next-line react/no-unused-prop-types
  dataResource: string // don't remove, this is used by the `withMetricClick` higher order component
|}

type Props = {
  ...OwnProps,
  ...ReduxStateProps,
  ...ReduxDispatchProps
}

const FlyerDetailMenu = ({
  resource,
  resourceId,
  flyer,
  primaryCTA,
  secondaryCTA,
  thirdCTA,
  fourthCTA,
  fifthCTA,
  onOpenModal
}: Props) => {
  const PrimaryCallToActionWMC = withMetricClick(
    primaryCTA && primaryCTA.metric, primaryCTA && primaryCTA.featureId
  )(FlyerButton) 
  const SecondaryCallToActionWMC = withMetricClick(
    secondaryCTA && secondaryCTA.metric, secondaryCTA && secondaryCTA.featureId
  )(FlyerButton) 
    const ThirdCallToActionWMC = withMetricClick(
    thirdCTA && thirdCTA.metric, thirdCTA && thirdCTA.featureId
  )(FlyerButton)
    const FourthCallToActionWMC = withMetricClick(
    fourthCTA && fourthCTA.metric, fourthCTA && fourthCTA.featureId
  )(FlyerButton)
    const FifthCallToActionWMC = withMetricClick(
    fifthCTA && fifthCTA.metric, fifthCTA && fifthCTA.featureId
  )(FlyerButton)
  
  return (
    <div>
      <div className={cn.buttonBar} >
      <div className="flyer-grid-menu__item" data-testid="go-back-content" style={{width: '20%'}}>
        <Link to={`/flyers/all/${resource}/${resourceId}`} aria-label="Back to School Flyers">
          <span style={styles.goBackContent}>
            <Icon as="span" size="large" name="chevron circle left" />{' '}
            <span className="mobile hidden">
              {capitalize(resource)} Flyers
            </span>
          </span>
        </Link>
      </div>
      {flyer && (
        <div style={styles.buttonsWrapper}>
          {secondaryCTA && (
            <SecondaryCallToActionWMC
              label={secondaryCTA.text}
              url={secondaryCTA.url}
              onClick={
                secondaryCTA.modalToOpen
                  ? () => onOpenModal(secondaryCTA.modalToOpen, secondaryCTA.value)
                  : null
              }
              type="secondary"
              dataTestid="secondary-cta"
            />
          )}
          {primaryCTA && (
            <PrimaryCallToActionWMC
              label={primaryCTA.text}
              url={primaryCTA.url}
              onClick={
                primaryCTA.modalToOpen
                  ? () => onOpenModal(primaryCTA.modalToOpen, primaryCTA.value)
                  : null
              }
              type="primary"
              dataTestid="primary-cta"
            />
          )}
        </div>
      )}
        <div className="flyer-grid-menu__item" style={{ width: '20%' }}>
        {flyer && (
          <SocialIcons
            flyerId={flyer.flyer_id}
            resource={resource}
            resourceId={resourceId}
            mapUrl={flyer.map_url}
            calendarUrl={flyer.calendar_url}
            openModal={onOpenModal}
          />
        )}
        </div>
      </div>
      {thirdCTA && <div className={cn.overflowButtonBar}>
        {fifthCTA && (
          <FifthCallToActionWMC
            style={{ border: '2px solid prussian'} }
            label={fifthCTA.text}
            url={fifthCTA.url}
            onClick={
              fifthCTA.modalToOpen
                ? () => onOpenModal(fifthCTA.modalToOpen, fifthCTA.value)
                : null
            }
            type="fifth"
            dataTestid="fifth-cta"
          />
        )}
        {fourthCTA && (
          <FourthCallToActionWMC
            style={{ border: '2px solid prussian'} }
            label={fourthCTA.text}
            url={fourthCTA.url}
            onClick={
              fourthCTA.modalToOpen
                ? () => onOpenModal(fourthCTA.modalToOpen, fourthCTA.value)
                : null
            }
            type="fourth"
            dataTestid="fourth-cta"
          />
        )}
        <ThirdCallToActionWMC
          label={thirdCTA.text}
          style={{ border: '2px solid prussian'} }
          url={thirdCTA.url}
          onClick={
            thirdCTA.modalToOpen
              ? () => onOpenModal(thirdCTA.modalToOpen, thirdCTA.value)
              : null
          }
          type="third"
          dataTestid="third-cta"
        />
      </div>}
    </div>
  )
}

const mapStateToProps = state => {
  const ctas = getFlyerCtas(state).map(mapCTA)
  return {
    primaryCTA: ctas[0],
    secondaryCTA: ctas[1],
    thirdCTA: ctas[2],
    fourthCTA: ctas[3],
    fifthCTA: ctas[4],
    flyer: getActiveFlyer(state)
  }
}

const mapDispatchToProps = dispatch => ({
  onOpenModal: (modalType: ?ModalTypes, value) => dispatch(openModal(modalType, value))
})

styles = {
  goBackContent: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '1em',
    fontWeight: 'bold'
  },
  buttonsWrapper: {
    color: white,
    display: 'flex',
    justifyContent: 'center'
  }
}

const cn = {
  buttonBar: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    font-family: 'Proxima Nova';
    height: 56px;
    background-color: #45506a;
    padding: 0.8rem 1rem;
    & a {
      color: white;
    }
    @media (max-width: 480px) {
      height: 51px;
    }
    & button {
      border: 2px solid;
      align-items: center;
      justify-content: center;
      margin: 0 2px;
      line-height: 1.33em;
      padding: .5rem;
      border-radius: .5em;
      & span {
        font-weight: bold;
        text-transform: none;
        padding-top: 1px;
      }
    }
  `,
  overflowButtonBar: css`
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'Proxima Nova';
    height: 56px;
    padding: 0.8rem 1rem;
    border-left: 1px solid ${ silver };
    border-right: 1px solid ${ silver };
    & a {
      color: white;
    }
    @media (max-width: 480px) {
      height: 51px;
    }
    & button {
      border: 2px solid ${ prussian };
      align-items: center;
      justify-content: center;
      margin: 0 2px;
      line-height: 1.33em;
      padding: .5rem;
      border-radius: .5em;
      & span {
        font-weight: bold;
        text-transform: none;
        padding-top: 1px;
      }
    }
  `
}
export default connect(mapStateToProps, mapDispatchToProps)(FlyerDetailMenu)

function mapCTA(cta: ?Cta) {
  const { type, value } = cta
  const primaryCTA = {
    'signup': { metric: 'signupnow' },
    'call': { metric: 'callnow-modal-open', modalToOpen: 'callFlyerOwner' },
    'donate': { metric: 'donatenow' },
    'email': { metric: 'email-modal-open', modalToOpen: 'emailFlyerOwner' },
    'app': { metric: isIOS ? 'ios-app-download' : 'android-app-download' },
    'getapp': { metric: isIOS || isBrowser ? 'ios-app-download' : 'android-app-download' },
    'join-meeting': { metric: 'joinmeeting' },
    'order': { metric: 'ordernow' },
    'register': { metric: 'registernow' },
    'rsvp': { metric: 'rsvpnow' },
    'subscribe': { metric: 'subscribenow' },
    'survey': { metric: 'surveynow' },
    'download': { metric: 'downloadnow'},
    'learn-more': { metric: 'learnmore'}
  }[type]

  if (primaryCTA) {
    primaryCTA.url = type !== 'call' && type !== 'email' ? value : null
    primaryCTA.text = ctaTexts[type]
    primaryCTA.featureId = cta.id
    primaryCTA.value = value
    return primaryCTA
  }

  return null
}


// WEBPACK FOOTER //
// ./src/screens/Flyers/screens/FlyerDetail/components/FlyerDetailMenu/index.js